module.exports = __webpack_public_path__ + "img/aegis.45a45105.jpg";